<template>
  <div>
    <div
      class="hero"
      :style="{
        '--backgroundImageSmall': `url(${images?.smallMedia})`,
        '--backgroundImageMedium': `url(${images?.mediumMedia})`,
        '--backgroundImageLarge': `url(${images?.largeMedia})`,
      }"
    >
      <div class="hero-copy">
        <h1 class="hero-copy__heading">RAT & BOA ATELIER x THE SEAM</h1>
        <P class="hero-copy__sub-heading">Wear Again, Love Forever.</P>
        <Button
          theme="white"
          class="hero-copy__button"
          tag="a"
          href="https://app.theseam.uk/ratandboa"
        >
          BOOK NOW
        </Button>
      </div>
    </div>
    <div class="intro">
      <p v-if="!mq.mdPlus" class="intro__p">
        Connect with local expert Makers to repair, alter and extend the life of
        your Rat & Boa favourites.
      </p>
      <h4 class="intro__heading">What is The Seam?</h4>
      <p class="intro__p">
        A convenient service that connects you with expert local Makers to
        repair and alter your Rat & Boa pieces. You can either request an
        in-person fitting service or simply send your item directly to your
        chosen specialist.
      </p>
      <Button
        theme="underline"
        tag="a"
        class="intro__button"
        href="https://app.theseam.uk/ratandboa"
      >
        EXPLORE MORE
      </Button>
    </div>
    <div v-if="!mq.mdPlus" class="mobile-image-one">
      <Picture :images="imageFour" />
    </div>
    <div v-if="mq.mdPlus" class="three-image-block">
      <Picture :images="imageOne" />
      <Picture :images="imageTwo" />
      <Picture :images="imageThree" />
    </div>
    <div class="how-it-works">
      <div class="how-it-works__title">
        <h4>HOW IT WORKS</h4>
      </div>
      <div class="grid">
        <div class="column-one">
          <div class="row-one">
            <img src="@/assets/icons/starV2.svg" />
            <!-- <i class="icon icon-starV2" /> -->
            <p>Choose Your Service</p>
          </div>
          <div class="row-two">
            <p>
              Alteration or repair? Tell us what you need and we’ll connect you
              to the right Maker.
            </p>
          </div>
        </div>
        <div class="column-two">
          <div class="row-one">
            <img src="@/assets/icons/ruler.svg" />
            <!-- <i class="icon icon-ruler" /> -->
            <p>Find Your Maker</p>
          </div>
          <div class="row-two">
            <p>
              After a quick chat, we’ll assign you to a local specialist from
              our network.
            </p>
          </div>
        </div>
        <div class="column-three">
          <div class="row-one">
            <img src="@/assets/icons/package.svg" />
            <!-- <i class="icon icon-package" /> -->
            <p>Book And Send Items</p>
          </div>
          <div class="row-two">
            <p>
              Your chosen specialist will be in touch within 48-hours and you
              can post your items directly or visit them in-person.
            </p>
          </div>
        </div>
      </div>
      <Button
        v-if="mq.mdPlus"
        theme="underline"
        tag="a"
        class="how-it-works__button"
        href="https://app.theseam.uk/ratandboa"
      >
        BOOK YOUR REPAIR OR ALTERATION
      </Button>
    </div>
    <div v-if="mq.mdPlus" class="image-quote">
      <Picture :images="quoteDesktopImage" />
      <div class="image-quote__quote-container">
        <p class="image-quote__quote">
          ‘Extending the life of our clothes through repairs and customisation
          is an easy and effective way to make favourite pieces last, and reduce
          our impact on the planet’
        </p>
        <p class="image-quote__author">VALENTINA & STEPHANIE</p>
      </div>
    </div>
    <div v-if="!mq.mdPlus" class="book-atelier">
      <Picture :images="bookMobileImage" />
      <div class="book-atelier__container">
        <p class="book-atelier__copy">
          ‘Extending the life of our clothes through repairs and customisation
          is an easy and effective way to make favourite pieces last, and reduce
          our impact on the planet’
        </p>
        <Button
          theme="white"
          class="book-atelier__button"
          tag="a"
          href="https://app.theseam.uk/ratandboa"
        >
          BOOK YOUR ALTERATION
        </Button>
      </div>
    </div>
    <div class="faq">
      <h5 class="faq__heading">FAQs</h5>
      <div class="faq__qanda container">
        <span>How do you set the price?</span>
        <p>
          Your Maker will determine the cost of your repair, ensuring a fair
          price is set. As a rough guide,
          <a href="https://www.theseam.uk/pricing"
            >view our fixed price list here</a
          >.
        </p>
        <span>When do I pay?</span>
        <p>
          Payment will be sent once you confirm your booking, and released to
          your Maker once they confirm the project has been completed.
        </p>
        <span>How long does it take?</span>
        <p>
          Each project timeline will be slightly different, but standard turn
          around time is 7-10 days.
        </p>
        <p>Services are limited to within the UK.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Picture from "@/components/Picture.vue";
import Button from "@/components/Button.vue";

export default {
  name: "SeamLanding",
  components: {
    Picture,
    Button,
  },
  inject: ["mq"],
  data() {
    return {
      quoteDesktopImage: {
        smallMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/image_20_3_1_1.jpg?v=1718022386",
        smallMedia2x:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/image_20_3_1_1.jpg?v=1718022386",
        mediumMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/image_20_3_1_1.jpg?v=1718022386",
      },
      imageOne: {
        smallMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Image_01_1_5a78b738-1708-45b2-b8d4-b3e0ae95c19e.jpg?v=1717677914",
        smallMedia2x:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Image_01_1_5a78b738-1708-45b2-b8d4-b3e0ae95c19e.jpg?v=1717677914",
        mediumMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Image_01_1_5a78b738-1708-45b2-b8d4-b3e0ae95c19e.jpg?v=1717677914",
      },
      imageTwo: {
        smallMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Image_02_1_3f79bd9b-6abf-4f26-854f-b9260f1cf091.jpg?v=1717677913",
        smallMedia2x:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Image_02_1_3f79bd9b-6abf-4f26-854f-b9260f1cf091.jpg?v=1717677913",
        mediumMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Image_02_1_3f79bd9b-6abf-4f26-854f-b9260f1cf091.jpg?v=1717677913",
      },
      imageThree: {
        smallMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Image_03_1_7d905e50-a038-426e-8bf2-3d6f84374c87.jpg?v=1717677913",
        smallMedia2x:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Image_03_1_7d905e50-a038-426e-8bf2-3d6f84374c87.jpg?v=1717677913",
        mediumMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Image_03_1_7d905e50-a038-426e-8bf2-3d6f84374c87.jpg?v=1717677913",
      },
      imageFour: {
        smallMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Image_01_1_5a78b738-1708-45b2-b8d4-b3e0ae95c19e.jpg?v=1717677914",
        smallMedia2x:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Image_01_1_5a78b738-1708-45b2-b8d4-b3e0ae95c19e.jpg?v=1717677914",
        mediumMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Image_01_1_5a78b738-1708-45b2-b8d4-b3e0ae95c19e.jpg?v=1717677914",
      },
      bookMobileImage: {
        smallMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/image_2_1_513d98b3-cab1-42e4-91b8-305ed57c60ae.jpg?v=1717683543",
        smallMedia2x:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/image_2_1_513d98b3-cab1-42e4-91b8-305ed57c60ae.jpg?v=1717683543",
        mediumMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/image_2_1_513d98b3-cab1-42e4-91b8-305ed57c60ae.jpg?v=1717683543",
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.hero {
  margin: 0 0 60px;
  position: relative;
  height: 70vh;
  overflow: hidden;
  background-image: url("https://cdn.shopify.com/s/files/1/0942/9062/files/image_1_2_1.jpg?v=1717668514");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  @include respond-above(sm) {
    background-image: url("https://cdn.shopify.com/s/files/1/0942/9062/files/image_1_2_1.jpg?v=1717668514");
  }

  @include respond-above(md) {
    margin: 0 0 80px;
    height: 90vh;
    background-image: url("https://cdn.shopify.com/s/files/1/0942/9062/files/image_1_1_1_d47e2ef0-aee4-4ef7-ae5a-120c2e4a8216.jpg?v=1717666747");
  }
}
.hero-copy {
  width: 100%;
  position: absolute;
  text-align: center;
  top: auto;
  bottom: 60px;
  &__heading {
    color: $color-white;
    margin: 0 auto;
    max-width: 1000px;
    text-wrap: balance;
    @include t__editorial-headline-30;
    @include respond-above(md) {
      @include t__editorial-headline-80;
    }
  }
  &__sub-heading {
    color: $color-white;
    font-family: $heading-font-family;
    font-size: 16px;
    font-style: italic;
    margin: 0 0 35px;
  }
  &__button {
    background-color: $color-white;
    color: $color-grey-dark;
    font-family: $utility-font-family;
    font-weight: 400;
    font-size: 13px;
    padding: 14px 28px;
    border-radius: 4px;
  }
}

.intro {
  text-align: center;
  margin: 0 0 60px;
  @include respond-above(md) {
    margin: 0 0 80px;
  }
  &__heading {
    margin: 40px 20px 20px;
    font-weight: 400;
    font-family: $utility-font-family;
    text-transform: none;
    font-size: 14px;
    @include respond-above(md) {
      text-transform: uppercase;
      font-family: $heading-font-family;
      font-size: 40px;
      margin: 0 20px 80px;
    }
  }
  &__p {
    margin: 20px 20px;
    font-size: 14px;
    text-wrap: pretty;
    font-family: $utility-font-family;
    max-width: 800px;
    @include respond-above(md) {
      font-size: 24px;
      margin: 0 auto 130px;
    }
  }
  &__button {
    background: none;
    border: none;
    font-family: $utility-font-family;
    font-size: 14px;
  }
}
.mobile-image-one {
  margin: 0 20px 60px;
}
.three-image-block {
  max-width: 1600px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 2px;
  margin: 0 auto 80px;
}
.how-it-works {
  text-align: center;
  display: block;
  padding: 0 20px;
  margin: 0 0 60px;
  .grid {
    margin: 0 0 80px;
    @include respond-above(md) {
      display: grid;
      max-width: 1600px;
      grid-template-columns: repeat(3, 1fr);
      margin: 0 auto 80px;
      column-gap: 100px;
    }
  }
  &__title {
    font-weight: 400;
    text-align: center;
    font-family: $utility-font-family;
    font-size: 20px;
    margin: 0 0 40px;
    @include respond-above(md) {
      font-family: $heading-font-family;
      font-size: 40px;
    }
  }
  .row-one {
    background-color: #f5f5f5;
    font-family: $utility-font-family;
    font-size: 15px;
    margin: 0 0 30px;
    padding: 20px;
    text-align: center;
    @include respond-above(md) {
      margin: 0 0 60px;
    }
  }
  .row-two {
    p {
      text-align: center;
      font-family: $utility-font-family;
      font-size: 14px;
      margin: 0 0 30px;
      @include respond-above(md) {
        margin: 0 0 0;
      }
    }
  }
}
.image-quote {
  max-width: 1600px;
  margin: 0 auto 80px;
  position: relative;
  &__quote-container {
    position: absolute;
    color: $color-white;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    bottom: 0;
    top: 0;
    right: 0;
    left: 0;
    flex-direction: column;
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
  }
  &__quote {
    font-size: 48px;
    font-family: $heading-font-family;
    text-transform: uppercase;
    text-wrap: pretty;
  }
  &__author {
    margin: 20px 0 0 0;
    font-family: $utility-font-family;
    font-size: 14px;
  }
}
.book-atelier {
  margin: 0 0 60px;
  position: relative;
  &__container {
    position: absolute;
    color: $color-white;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    bottom: 0;
    top: 0;
    right: 0;
    left: 0;
    flex-direction: column;
    margin: 0 auto;
    text-align: center;
  }
  &__copy {
    font-size: 32px;
    font-family: $heading-font-family;
    text-transform: uppercase;
    text-wrap: pretty;
    margin: 0 20px 20px;
  }
  &__button {
    background-color: $color-white;
    color: $color-grey-dark;
    font-family: $utility-font-family;
    font-weight: 400;
    font-size: 13px;
    padding: 14px 28px;
    border-radius: 4px;
  }
}
.faq {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  &__heading {
    font-size: 36px;
    font-family: $heading-font-family;
    // font-style: italic;
    margin: 0 0 60px;
    @include respond-above(md) {
      margin: 0 0 80px;
    }
  }
  &__qanda {
    font-family: $utility-font-family;
    font-size: 14px;
    margin: 0 0 60px;
    @include respond-above(md) {
      margin: 0 0 80px;
    }
    p {
      margin: 0 0 20px;
    }
    span {
      display: block;
      margin: 0 0 20px;
      font-weight: 600;
    }
  }
}
</style>
